import styled from 'styled-components';
// import BgImage from '../../../assets/image/gojoylab/map.png';

const DisplaySectionWrapper = styled.section`
  padding: 120px 0;
  background: linear-gradient(to right, #ffffff 0%, #ffffff 50%, #fafafa 100%);
  background-repeat: no-repeat;
  background-position: 25% center;
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media (max-width: 990px) {
    padding: 100px 0;
    .desktop {
      display: block !important;
    }
    .mobile {
      display: none !important;
      margin: auto;
    }
  }
  @media (max-width: 767px) {
    padding: 80px 0;
    .desktop {
      display: none !important;
    }
    .mobile {
      display: block !important;
      max-width: 100%;
      width: 60%;
      margin: auto;
      margin-bottom: 30%;
    }
  }
  @media (max-width: 575px) {
    padding: 60px 0;
  }
`;

export default DisplaySectionWrapper;
